import ClientLike from "@/api/client-like";
import Subtask from "./subtask";

export default class SubtaskApi {
  public constructor(private client: ClientLike) {}

  public async save(subtask: Subtask): Promise<void> {
    this.client.post("save_subtask.php", subtask.toFormData());
  }

  public async delete(id: string | number): Promise<void> {
    const d = new FormData();
    d.append("id", String(id));
    this.client.post("delete_subtask.php", d);
  }
}
